import { Component, inject, input, model } from '@angular/core';
import { CardHictoryPlayer } from '../../services/history/card-hictory-player';

@Component({
  selector: 'app-card-counter',
  imports: [],
  templateUrl: './card-counter.html',
  styleUrl: './card-counter.scss'
})
export class CardCounter {
  showCard = model<any>();
  mobileProgressWindow = input(false);

  cardHictory = inject(CardHictoryPlayer);

  getCurrentCard(){
    return this.cardHictory.countReverse(this.showCard().type_id, this.showCard().level);
  }

  getTotalCards() {
    return this.cardHictory.allCoundCardLevel(this.showCard().type_id, this.showCard().level);
  }

  getCardDisplay() {
    const current = this.getCurrentCard();
    const total = this.getTotalCards();
    const mobileWindowStart = Math.min(total, Math.max(current + 1, 5));
    const mobileSlots = Array.from({ length: Math.min(total, 5) }, (_, index) => {
      const value = mobileWindowStart - index;
      const state = value > current ? 'ready' : value === current ? 'now' : 'next';

      return {
        value,
        state,
        isLast: index === Math.min(total, 5) - 1 && state === 'next'
      };
    });

    return {
      current,
      total,
      isFirst: current == total,
      isLast: current === 1,
      prev: current < total ? current + 1 : null,
      next: current > 1 ? current - 1 : null,
      prevs: current <= 2 ? [3, 2].filter(n => n <= total && n > current) : null,
      mobileSlots
    };
  }

}
